import { toArray, isEmpty } from "../utils/primitives";
import { maybe } from "../utils/functional";

type UseSelect = {
  value?: string | string[] | Record<string, unknown> | Record<string, unknown>[];
  multi?: boolean;
  full?: boolean;
  valueKey?: string;
  onChange?: () => void;
};

export function useSelect(args: UseSelect = {}) {
  const { value, multi, full, valueKey, onChange } = args;
  // TODO remove any

  function handleChange(item: any) {
    const { value } = item;
    let mapped = full ? value : value.map((v) => v[valueKey]);
    if (!multi) {
      mapped = mapped[0];
    }
    return maybe(onChange)(mapped);
  }
  function toValue(value) {
    if (isEmpty(value)) {
      return value;
    }
    value = toArray(value);
    return full ? value : value.map((v) => ({ [valueKey]: v }));
  }
  return [toValue(value), handleChange];
}
